import * as React from 'react';

import CatalogItemCard from '@/components/GridItemCard/Card/CardOptions/CatalogItemCard/CatalogItemCard';
import { ItemCardComponent, ItemCardInfo } from '@/components/GridItemCard/types/types';
import { useAppSelector } from '@/redux/hooks';
import { getItemSummaryIsTimedPlusAuction } from '@/redux/modules/item/summary/itemSummary.selectors';

import { TimedPlusItemCard } from '../index';

const TimedOrCatalogCard: ItemCardComponent = (props) => {
    const isTimedPlus = useAppSelector((state) => getItemSummaryIsTimedPlusAuction(state, props.itemId));

    const Component = isTimedPlus ? TimedPlusItemCard.ItemCardComponent : CatalogItemCard.ItemCardComponent;

    return <Component {...props} />;
};

const info: ItemCardInfo = { ItemCardComponent: TimedOrCatalogCard };

export default info;
